import { StorageKind } from './storage';

export type StorageSubscriber = () => void;

const subscribers = new Map<string, Set<StorageSubscriber>>();

const subKey = (kind: StorageKind, key: string) => `${kind}:${key}`;

let isCrossTabListenerAttached = false;
const attachCrossTabListenerOnce = () => {
  if (isCrossTabListenerAttached) return;
  if (typeof window === 'undefined') return;
  try {
    window.addEventListener('storage', (e: StorageEvent) => {
      if (!e.key) return;
      // Only localStorage triggers cross-document events
      StorageSubscribe.notify(StorageKind.Local, e.key);
    });
    isCrossTabListenerAttached = true;
  } catch {
    console.warn('Failed to attach cross-tab listener');
  }
};

export const StorageSubscribe = {
  subscribe: (
    kind: StorageKind,
    key: string,
    cb: StorageSubscriber
  ): (() => void) => {
    attachCrossTabListenerOnce();
    const k = subKey(kind, key);
    const set = subscribers.get(k) ?? new Set<StorageSubscriber>();
    set.add(cb);
    subscribers.set(k, set);
    return () => {
      const existing = subscribers.get(k);
      if (!existing) return;
      existing.delete(cb);
      if (existing.size === 0) subscribers.delete(k);
    };
  },
  notify: (kind: StorageKind, key: string): void => {
    const k = subKey(kind, key);
    const set = subscribers.get(k);
    if (!set || set.size === 0) return;
    set.forEach((cb) => {
      try {
        cb();
      } catch {
        console.warn('Failed to notify storage subscriber');
      }
    });
  },
};
